import { Fragment, h } from "preact";

import tracking from "../tracking/tracking";

const PAGES_AROUND_CURRENT = 3;

export default function Pagination({
  currentPage,
  prevPage,
  nextPage,
  gotoPage,
  totalPages,
}) {
  const needsPagination = totalPages > 1;

  const hasPrevious = currentPage > 1;
  const hasNext = currentPage < totalPages;

  const pages = [];

  for (
    let i = Math.max(1, currentPage - PAGES_AROUND_CURRENT);
    i <= Math.min(totalPages, currentPage + PAGES_AROUND_CURRENT);
    i++
  ) {
    pages.push(i);
  }

  const pagesBeforeElipsis = [];
  for (let i = 1; i <= currentPage - PAGES_AROUND_CURRENT - 1; i++) {
    pagesBeforeElipsis.push(i);
  }

  const pagesAfterElipsis = [];
  for (let i = currentPage + PAGES_AROUND_CURRENT; i <= totalPages; i++) {
    pagesAfterElipsis.push(i);
  }

  const showFirstPage = pages[0] > 1;
  const showFirstPageEllipsis = pages[0] > 2;
  const showLastPage = pages[pages.length - 1] < totalPages;
  const showLastPageEllipsis = pages[pages.length - 1] < totalPages - 1;

  function track(num) {
    tracking.track("pagination.click", { on: num, total: totalPages });
  }

  if (!needsPagination) {
    return null;
  }
  return (
    <div class="pagination">
      {hasPrevious && (
        <a
          class="pagination__caret pagination__caret--left"
          onClick={() => {
            track("prev");
            prevPage();
          }}
        >
          &lt;
        </a>
      )}
      {showFirstPage && (
        <a
          class="pagination__item"
          onClick={() => {
            track(1);
            gotoPage(1);
          }}
        >
          1
        </a>
      )}
      {showFirstPageEllipsis && <span class="pagination__elipsis">…</span>}
      {pages.map((index) =>
        index === currentPage ? (
          <span class="pagination__item pagination__item--current">
            {" "}
            {index}
          </span>
        ) : (
          <a
            class="pagination__item"
            href="#"
            onClick={() => {
              track(index);
              gotoPage(index);
            }}
          >
            {index}
          </a>
        )
      )}
      {showLastPageEllipsis && <span class="pagination__elipsis">…</span>}
      {showLastPage && (
        <a
          class="pagination__item"
          onClick={() => {
            track(totalPages);
            gotoPage(totalPages);
          }}
        >
          {totalPages}
        </a>
      )}
      {hasNext && (
        <a
          class="pagination__caret pagination__caret--right"
          onClick={() => {
            track("next");
            nextPage();
          }}
        >
          &gt;
        </a>
      )}
    </div>
  );
}
